// Module
var code = "<select class=\"form-control\" data-bind=\"options: _items, value: Value\"></select> ";
// Exports
export default code;